import Vue from "vue";
import axios from 'axios';
import Qs from 'qs';
import {url} from './location.js';
import Router  from '../router/index.js'
import router from 'vue-router';
import { Toast} from 'vant';
Vue.use(Toast);
Vue.prototype.ajaxUrl = url;
export const retureState = function (res,obj) {
	if(res.success){
        obj.success(res);
    }else if(res.status_code=='201'){
        if(obj.islogin){
            var querydata=''
            if(obj.query){
                querydata== {
                    uid: obj.query.uid?obj.query.uid:'',
                    tuserid: obj.query.tuserid?obj.query.tuserid:'',
                    status:obj.query.status?obj.query.status:'',
            	}
            }
            Router.push({
            	path: 'login',
            	query:querydata
            });
        }else{
            if(typeof obj.login=='function'){
               obj.login(res);
            }
        }
    }else{
        Toast(res.message);
        if(typeof obj.fail=='function'){
           obj.fail(res);
        }
    }
}
//首页公告

export const getData = function (obj) {
    this.axios.post(this.ajaxUrl(obj.target?obj.target:'etp',obj.url), Qs.stringify(obj.data)
    // {headers:{
    //     'Content-Type': 'application/json',
    //     Cookie:'SERVERID='+localStorage.getItem('token')
    // },
    ).then((res) => {
        retureState(res.data,obj);
        if(typeof obj.complete=='function'){
            obj.complete(res);
        }
    })
}